import { defineStore } from "pinia";

export const usePageStore = defineStore("page", {
    state: () => ({
        pageData: [],
        navData: null,
    }),
    actions: {
        setPageData(data) {
            this.pageData = data;
        },
        setNavData(data) {
            this.navData = data;
        },
    },
});
